(function () {
  'use strict';

  angular
    .module('virtualFairs')
    .controller('VirtualFairCyberSessionStudentsController', VirtualFairCyberSessionStudentsController)

    VirtualFairCyberSessionStudentsController.$inject = ['$uibModalInstance', 'students'];

  function VirtualFairCyberSessionStudentsController($uibModalInstance, students) {
    var vm = this;

    vm.students = students;
    vm.ok = ok;
    vm.cancel = cancel;
    vm.errors = false;

    vm.logicOptions = [
      {id: 0, name: 'No'},
      {id: 1, name: 'Yes'}
    ];

    activate();

    function activate() {
    }

    function ok () {
      $uibModalInstance.close();
    }

    function cancel () {
      $uibModalInstance.close();
    }
  }

})();